import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addJob, deleteJob, editJob, getJob, getJobs } from "./jobsAPI";

const initialState = {
  jobs: [],
  isLoading: false,
  isError: false,
  error: "",
  editing: {},
  filter:{
    search: "",
    sort: "Default"
  }
};

// async thunks
export const fetchJobs = createAsyncThunk("job/fetchjobs", async (value) => {
  const jobs = await getJobs(value);
  return jobs;
});

export const fetchJob = createAsyncThunk("job/fetchjob", async (id) => {
  const job = await getJob(id);
  return job;
});

export const createJob = createAsyncThunk("job/createjob", async (data) => {
  const job = await addJob(data);
  return job;
});

export const changeJob = createAsyncThunk(
  "job/changejob",
  async ({ id, data }) => {
    const job = await editJob(id, data);
    return job;
  }
);

export const removeJob = createAsyncThunk("job/removejob", async (id) => {
  const job = await deleteJob(id);
  return job;
});

// create slice
const jobsSlice = createSlice({
  name: "job",
  initialState,
  reducers:{
    filterBySearch(state, action){
        state.filter.search = action.payload;
    },
    filterBySort(state, action){
        state.filter.sort = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobs.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchJobs.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.jobs = action.payload;
      })
      .addCase(fetchJobs.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
        state.jobs = [];
      })
      .addCase(createJob.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(createJob.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.jobs.push(action.payload);
      })
      .addCase(createJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(changeJob.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(changeJob.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;

        const indexToUpdate = state.jobs.findIndex(
          (t) => t.id === action.payload.id
        );

        state.jobs[indexToUpdate] = action.payload;
        state.editing = {};
      })
      .addCase(changeJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(removeJob.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(removeJob.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;

        state.jobs = state.jobs.filter((t) => t.id !== action.meta.arg);
      })
      .addCase(removeJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(fetchJob.pending, (state) => {
        state.isError = false;
        state.isLoading = true;
      })
      .addCase(fetchJob.fulfilled, (state, action) => {
        state.isError = false;
        state.isLoading = false;
        state.editing = action.payload;
      })
      .addCase(fetchJob.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.error?.message;
        state.editing = {};
      });
  },
});

export default jobsSlice.reducer;
export const { filterBySearch, filterBySort } = jobsSlice.actions;